<template>
    <div class="w-100 h-100" :class="notch ? 'hasNotch' : ''">
        <div id="app-container" class="container-md pb-5">

            <div class="text-center text-lg-right sticky-top" @click="top()">
                <div class="logo my-3" rel="preload"></div>
            </div>
            <router-view class="router" :class="'page-'+$page" v-bind:class="$page != 'Home' ? 'sticky' : ''"
                         @user="setUser" :user="user" :page="$page"
                         v-if="this.user || this.$route.name == 'Login'"/>

        </div>
        <div v-if="this.$alert" class="alert global-alert alert-dismissible fade show"
             :class="this.$alert.type ? 'alert-'+this.$alert.type : 'alert-dark'">
            <div class="alert-heading text-center" v-if="this.$alert.title">{{ this.$alert.title }}</div>
            {{ this.$alert.message }}
        </div>

        <div v-if="showDialog" id="notification" class="alert alert-primary fixed-bottom mb-5" @click="reload">A new version of this app is available. Click <a id="reload">here</a> to update.</div>
        <div v-if="!this.$authenticated">
            <div class="wave water"></div>
            <div class="wave water"></div>
            <div class="wave water"></div>
            <div class="wave water"></div>
        </div>

        <Footer v-if="this.$authenticated" :user="user" page="page"></Footer>
    </div>
</template>

<script>
import axios from "axios";
import {sha256} from "js-sha256";
import Header from "@/views/partials/Header";
import Footer from "@/views/partials/Footer";

let alertTimeout;

export default {
    name: 'App',
    components: {
        Footer,
        Header
    },
    data() {
        return {
            user: null,
            logoOpacity: 1,
            page: 'Home',
            alert: null,
            isSubscribed: false,
            showDialog: false,
            notch: false
        }
    },
    mounted() {
        let self = this;
        this.saveIOSToken = window.vm;
        axios.interceptors.request.use(function (config) {
            let myDate = new Date();
            let newDate = new Date(myDate.getFullYear() + '-' + (myDate.getMonth() + 1) + '-' + myDate.getDate() + ' ' + myDate.getHours() + ':' + myDate.getUTCMinutes() + ':00');
            let API_TOKEN = sha256(((self.$session.has('API_KEY') ? self.$session.get('API_KEY') : '')));
            config.headers.Authorization = 'Bearer ' + API_TOKEN;
            config.baseURL = process.env.API_URL;
            return config;
        });

        if (self.$session.has('token') && this.$session.has('id')) {
            self.$authenticated = true;
            if (!self.user) {
                axios.get("/api/user/" + self.$session.get('id') + "/get")
                    .then(response => {
                        self.user = response.data[0];
                    });
            }
        }
        if (!self.$authenticated) {
            self.$router.replace({name: "Login"});
            document.getElementsByTagName('body')[0].classList.add('page--login');
        }
        self.$watch(self => [self.$authenticated, self.$swRegistration], () => {
            if (self.$authenticated && self.$swRegistration != null) {
                self.initializeNotifications();
            }
        });
    },
    methods: {
        reload: function () {
            window.location.reload();

        },
        setUser(user) {
            let self = this;
            self.user = user;
        },
        top() {
            $('.router').scrollTop(0);
        },
        async accept() {
            this.showUpgradeUI = false
            await this.$workbox.messageSW({type: "SKIP_WAITING"});
        },
        initializeNotifications: function () {
            // console.log('initializeNotifications');
            let self = this;
            self.$swRegistration.pushManager.getSubscription()
                .then(function (subscription) {
                    self.isSubscribed = !(subscription === null);

                    if (self.isSubscribed) {
                        // console.log('User IS subscribed.');
                    } else {
                        // console.log('User is NOT subscribed.');
                        self.subscribeUser();
                    }
                });
        },
        subscribeUser: function () {
            let self = this;
            const applicationServerKey = self.$session.get('API_KEY');
            self.$swRegistration.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: applicationServerKey
            })
                .then(function (subscription) {
                    // console.log('User is subscribed.');
                    self.$subscription = subscription;
                })
                .catch(function (err) {
                    // console.log('Failed to subscribe the user: ', err);
                });
        },
        urlBase64ToUint8Array: function (base64String) {
            let padding = '='.repeat((4 - base64String.length % 4) % 4);
            let base64 = (base64String + padding)
                .replace(/\-/g, '+')
                .replace(/_/g, '/');

            let rawData = window.atob(base64);
            let outputArray = new Uint8Array(rawData.length);

            for (let i = 0; i < rawData.length; ++i) {
                outputArray[i] = rawData.charCodeAt(i);
            }
            return outputArray;
        },
        saveToken: function () {
            let self = this;
            if (self.$subscription && self.user.id) {
                // console.log('saveToken')
                self.isSubscribed = true;
                let formData = new FormData();
                formData.append('user_id', self.user.id);
                formData.append('subscription', JSON.stringify(self.$subscription));
                axios.post("/api/notification/subscribe", formData).then(response => {
                    if (response.data) {
                        // console.log(response.data);
                    }
                });
            }
        },
        setIOSToken: function (token) {
            if (token !== '') {
                let jsonString = {
                    'keys': {
                        'auth': '',
                        'p256dh': token
                    },
                    'endpoint': 'ios',
                    'expirationTime': null
                }
                this.$subscription = jsonString;
            }
        },
        hasNotch: function (val) {
            this.notch = val;
        }
    },
    watch: {
        $alert: function () {
            let self = this;

            clearTimeout(alertTimeout);

            alertTimeout = setTimeout(function () {
                $('.global-alert').alert('close');
                self.$alert = null;
            }, 5000)
        },
        $route: {
            handler(to, from) {
                const body = document.getElementsByTagName('body')[0];
                if (from !== undefined) {
                    body.classList.remove('page--' + from.name.toLowerCase());
                }
                body.classList.add('page--' + to.name.toLowerCase());
            },
            immediate: false
        },
        $updateShow: function () {
            // this.showDialog = true;
        },
        changeData: {
            handler: function (val) {
                if (val[0] && val[1]) {
                    this.saveToken();
                }
            },
            deep: true
        }
    },
    created() {
        if (this.$workbox) {
            this.$workbox.addEventListener("waiting", () => {
                this.showUpgradeUI = true;
            });
        }
        window.setIOSToken = this.setIOSToken;
        window.hasNotch = this.hasNotch;
    },
    computed: {
        changeData() {
            return [this.$subscription, this.user]
        }
    }
}

</script>
<style lang="scss">
@import "https://fonts.googleapis.com/css?family=Nunito";
</style>



// WEBPACK FOOTER //
// src/App.vue